import { render, staticRenderFns } from "./MobileCore.vue?vue&type=template&id=74c5d35e&scoped=true"
import script from "./MobileCore.vue?vue&type=script&lang=ts"
export * from "./MobileCore.vue?vue&type=script&lang=ts"
import style0 from "./MobileCore.vue?vue&type=style&index=0&id=74c5d35e&prod&lang=scss"
import style1 from "./MobileCore.vue?vue&type=style&index=1&id=74c5d35e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c5d35e",
  null
  
)

export default component.exports